import {
    type MaybeRefOrGetter,
    onMounted,
    onScopeDispose,
    toValue
} from 'vue';

/**
 * Registers a global `keydown` listener that invokes `callback` when the Escape
 * key is pressed with a trusted event.
 *
 * The listener is added on mount and removed before unmount.
 *
 * @param callback - Callback invoked on Escape keydown.
 * @param disabled - When resolves to `true`, the callback is suppressed.
 */
export const useEscKey = (
    callback: () => void,
    disabled?: MaybeRefOrGetter<boolean>,
) => {
    const handleKeydown = (event: KeyboardEvent): void => {
        if (!event.isTrusted) return;
        if (event.key !== 'Escape') return;
        if (toValue(disabled)) return;

        callback();
    };

    onMounted(() => window.addEventListener('keydown', handleKeydown));
    onScopeDispose(() => window.removeEventListener('keydown', handleKeydown));
};
